import {
  UserProfileUpdateDocument,
  UserProfileUpdateMutation,
  UserProfileUpdateMutationVariables,
  ContactUpdateInput,
} from "@graphql/api";

interface UpdatedFields {
  contact?: ContactUpdateInput;
  linkedReservations?: Array<string>;
}

export default async function userProfileUpdate(
  updatedFields: UpdatedFields
): Promise<boolean> {
  const client = global.window.apolloClient;

  // Extract contact and linkedReservations from updatedFields
  const { contact, linkedReservations } = updatedFields;

  const mutVars: UserProfileUpdateMutationVariables = { 
    contact,
    linkedReservations 
  };
  
  const result = await client.mutate<UserProfileUpdateMutation>({
    mutation: UserProfileUpdateDocument,
    variables: mutVars,
  });

  if (result.data?.updateUserProfile?.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.updateUserProfile?.success ?? false;
}
